import conversationCache from 'owa-mail-store/lib/store/conversationCache';
import type ConversationItem from 'mini-mail-list-store/lib/store/schema/ConversationItem';
import type ConversationItemParts from 'owa-mail-store/lib/store/schema/ConversationItemParts';
import getTableToItemRelationKey from 'mini-mail-list-store/lib/utils/getTableToItemRelationKey';
import listViewStore from 'mini-mail-list-store/lib/store/Store';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import type TableViewConversationRelation from 'mini-mail-list-store/lib/store/schema/TableViewConversationRelation';
import { action, select } from 'satcheljs/lib/legacy';
import type { MruCache } from 'owa-mru-cache';
import type { ObservableMap } from 'mobx';

export interface RemoveConversationDataState {
    tableViewConversationRelations: ObservableMap<string, TableViewConversationRelation>;
    tableViews: ObservableMap<string, TableView>;
    conversationItems: ObservableMap<string, ConversationItem>;
    conversationCache: MruCache<ConversationItemParts>;
}

export default select<RemoveConversationDataState>({
    tableViewConversationRelations: () => listViewStore.tableViewConversationRelations,
    tableViews: () => listViewStore.tableViews,
    conversationItems: () => listViewStore.conversationItems,
    conversationCache: () => conversationCache,
})(
    action('removeConversationData')(function removeConversationData(
        conversationId: string,
        tableView: TableView,
        state?: RemoveConversationDataState
    ) {
        const tableConversationRelationKey = getTableToItemRelationKey(
            conversationId,
            tableView.id
        );
        const tableConversationRelations = state.tableViewConversationRelations;

        if (!tableConversationRelations.has(tableConversationRelationKey)) {
            throw new Error('Conversation not found in store');
        }

        // 1. If the conversation being removed is selected, remove item from selected item ids.
        // This should be done before we delete tableConversationViewStateRelation as this sets
        // isSelected property on it.
        tableView.selectedItemsIds.delete(conversationId);

        // 2. Remove table Conversation relation
        tableConversationRelations.delete(tableConversationRelationKey);

        // 3. Check to see if there are any other table relations for this converation
        let converationFoundInOtherTables = false;
        for (const tableView of [...state.tableViews.values()]) {
            const tableConversationRelationKey = getTableToItemRelationKey(
                conversationId,
                tableView.id
            );
            if (tableConversationRelations.has(tableConversationRelationKey)) {
                converationFoundInOtherTables = true;
                break;
            }
        }

        // 4. Only remove conversation from listview store when it is not referenced anymore from any table
        if (!converationFoundInOtherTables) {
            state.conversationItems.delete(conversationId);

            // Remove cached ConversationItemParts from conversationCache if exists
            state.conversationCache.remove(conversationId);
        }
    })
);
